export default function GoalPicker({ goals, effortName, setsGoalId, onGoalChange }) {
  if (goals.length === 0) return null;

  if (goals.length === 1) {
    return (
      <label className='margin-top half align-center complete-goal'>
        <input
          type='checkbox'
          className='margin-right half'
          checked={setsGoalId !== null}
          onChange={(e) => { console.log(goals[0]); onGoalChange(setsGoalId ? null : goals[0].id) }}
        />
        <span>Complete goal for {effortName}</span>
      </label>
    );
  }

  let goalChoices = goals
  if (goals[0].name.includes('[Salesforce]')) {
    // Remove the primary goal for salesforce as it is a dummy goal
    goalChoices = goals.slice(1).sort((a, b) => a.id - b.id);
  }

  return (
    <div className='margin-top half multiple-goals'>
      <span className='dark-grey bold'>Complete goal</span>
      <select
        className='goal-picker'
        value={setsGoalId || ''}
        onChange={(e) => onGoalChange(e.target.value || null)}
      >
        <option value="">Do not complete a goal</option>
        {goalChoices.map(goal => (
          <option key={goal.id} value={goal.id}>
            {goal.name}
          </option>
        ))}
      </select>
    </div>
  );
}
